import { render } from "./ItemControls.vue?vue&type=template&id=26160b46&scoped=true"
import script from "./ItemControls.vue?vue&type=script&lang=js"
export * from "./ItemControls.vue?vue&type=script&lang=js"

import "./ItemControls.vue?vue&type=style&index=0&id=26160b46&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26160b46"]])

export default __exports__